import axios from 'axios'
import { configuration as config } from './utils'
import { getToken, logout } from './authentication'
import { useToast } from 'vuestic-ui'

// Create custom axios instance
const httpAuth = axios.create({
  baseURL: config.BASE_API_URL + '/',
})

const { init } = useToast()

// set request interceptor to set JWT token and header information
httpAuth.interceptors.request.use((config) => {
  const token = getToken()

  if (token == null) {
    logout()
    // should we do an alert here??
    // TODO: look into this
    init({
      message: 'You are not logged in. <a href="/auth/login" class="va-link underline">Please login again.</a>',
      color: 'warning',
      dangerouslyUseHtmlString: true,
    })
    return Promise.reject('User is not logged in.') // may not reach here since the page will reload
  }

  config.headers['Authorization'] = `Bearer ${token}`
  return config
})

httpAuth.interceptors.response.use(
  (response) => response,
  function (error) {
    if ((error.response?.status ?? 0) == 401) {
      init({ message: 'Your session has expired.', color: 'warning' })
      logout()
    }

    return Promise.reject(error)
  },
)

export default httpAuth
